import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PromotionGroupOptionLabel from './PromotionGroupOptionLabel';
import Radio from '../Common/Radio';

export default class PromotionGroupOptions extends Component {
  render() {
    return (
      <div>
        {this.props.promotions.map((promotion, index) =>
          <div key={index}>
            <Radio
              name={promotion.name}
              value={promotion.id}
              label={
                <PromotionGroupOptionLabel
                  promotion={promotion}
                  currency={this.props.store.currency.code}
                />
              }
              selectedValue={this.props.selectedPromotionId}
              onChange={this.props.handlePromotionChange}
              disabled={this.props.disabled}
            />
          </div>)}
        </div>
    );
  }
}

PromotionGroupOptions.PropTypes = {
  promotion: PropTypes.shape({
    id: PropTypes.number.required,
    name: PropTypes.string.required,
    price: PropTypes.shape({
      sellingPrice: PropTypes.number.required,
      totalAmount: PropTypes.number.required,
    }).required,
  }).required,
  handlePromotionChange: PropTypes.func.required,
  selectedPromotionId: PropTypes.string.required,
  store: PropTypes.shape({
    currency: PropTypes.shape({
      code: PropTypes.string.required,
    }).required,
  }).required,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/Promotion/PromotionGroupOptions.js